<template>
  <svg width="10"
       height="11"
       viewBox="0 0 10 11"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <circle cx="5" cy="5.5" r="5" :fill="color" />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#45D72D"
    }
  }
}
</script>
